<script>
import config from "@/utils/config";
import axios from "axios";
export default {
  name: 'QuestionarioConoscitivo',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
        eta: '',
        birthdate: '',
        sex: '',
        studentClass: '',
        section: '',
        school: '',
        address: '',
        alreadyUsedRepetitions: false,
        frequencyUsedTutoring: '',
        alreadyUsedTutoringOnline: false,
        frequencyOfOnlineTutoring: '',
        givenTutoring: false,
        frequencyGivenTutoring: '',
        givenTutoringOnline: false,
        errorMessage: ''
    };
  },
  methods: {
    validateForm() {
        if (!this.eta || !this.birthdate || !this.sex || !this.studentClass || !this.school || !this.address) {
            this.errorMessage = "Compila tutti i campi obbligatori.";
            return;
        }

        if (this.alreadyUsedRepetitions && !this.frequencyUsedTutoring) {
            this.errorMessage = "Se hai usufruito di ripetizioni, indica la frequenza.";
            return;
        }

        if (this.alreadyUsedTutoringOnline && !this.frequencyOfOnlineTutoring) {
            this.errorMessage = "Se hai usato ripetizioni online, indica la frequenza.";
            return;
        }

        if (this.givenTutoring && !this.frequencyGivenTutoring) {
            this.errorMessage = "Se hai dato ripetizioni, indica la frequenza.";
            return;
        }

        if(this.birthdate) {
            let today = new Date();
            if(new Date(this.birthdate) > today) {
                this.errorMessage = "La data di nascita non può essere futura rispetto al giorno corrente.";
                return;
            }
            const date = new Date(this.birthdate);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const valid_year = today.getFullYear() - 100;
            if (year < valid_year || year > today.getFullYear()) {
                this.errorMessage = `La data di nascita non risulta valida`;
                return;
            }
            this.birthdate = `${year}-${month}-${day}`;
        }

        this.errorMessage = '';
        axios.post(config.baseUrl + '/user/questionario-conoscitivo', {
            id: this.user.id,
            age: this.eta,
            dataNascita: this.birthdate,
            sex: this.sex,
            studentClass: this.studentClass,
            section: this.section,
            school: this.school,
            address: this.address,
            alreadyUsedRipetitions: this.alreadyUsedRepetitions,
            frequencyUsedTutoring: this.frequencyUsedTutoring,
            alreadyUsedTutoringOnline: this.alreadyUsedTutoringOnline,
            frequencyOfOnlineTutoring: this.frequencyOfOnlineTutoring,
            givenTutoring: this.givenTutoring,
            frequencyGivenTutoring: this.frequencyGivenTutoring,
            givenTutoringOnline: this.givenTutoringOnline
        });
        this.$emit('completed');
    },
    setRicevutoRipetizioniOnline(value) {
        this.alreadyUsedTutoringOnline = value;
        // If user selects "NO", clear the frequency field
        if (!value) {
            this.frequencyOfOnlineTutoring = '';
        }
    },
    setDatoRipetizioni(value) {
        this.givenTutoring = value;
        // If user selects "NO", clear related fields and set defaults
        if (!value) {
            this.frequencyGivenTutoring = '';
            this.givenTutoringOnline = false;
        }
    },
    setDatoRipetizioniOnline(value) {
        this.givenTutoringOnline = value;
    },
    calculateAge() {
        if (this.birthdate) {
            const birthDate = new Date(this.birthdate);
            const today = new Date();

            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();

            // If birthday hasn't occurred yet this year, subtract one from age
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            this.eta = age;
        } else {
            this.eta = '';
        }
    },
  },
  watch: {
    birthdate() {
      this.calculateAge();
    },
    alreadyUsedRepetitions(value) {
      // If "Hai mai usufruito di ripetizioni?" is set to NO, reset related fields
      if (!value) {
        this.frequencyUsedTutoring = '';
        this.alreadyUsedTutoringOnline = false;
        this.frequencyOfOnlineTutoring = '';
      }
    }
  }
}
</script>
<template>
    <div class="container">
    <div class="questionario-box">
        <h2>Questionario conoscitivo</h2>
        <p>Il questionario che stai per compilare ci aiuterà a capire meglio chi sei e come possiamo aiutarti.</p>

        <div class="form-group">
            <label>Data di nascita:</label>
            <input type="date" v-model="birthdate" class="input-section"/>
        </div>

        <div class="form-group">
            <label>Sesso:</label>
            <select v-model="sex">
            <option value="">Seleziona</option>
            <option value="M">M</option>
            <option value="F">F</option>
            <option value="Altro">Altro</option>
            <option value="Non Dichiarato">Non dichiarato</option>
            </select>
        </div>

        <div class="form-group">
            <label>Classe frequentata:</label>
            <div class="input-group">
            <input
                type="number"
                v-model="studentClass"
                min="1"
                max="9"
                placeholder="Classe"
                class="input-classe"
                style="border-right: 1px solid #ccc;"
                @input="studentClass = studentClass.toString().slice(0,1)"
            />
            <input
                type="text"
                v-model="section"
                maxlength="5"
                placeholder="Sezione"
                class="input-section"
                style="border-left: 1px solid #ccc;"
                @input="section = section.slice(0, 5)"
            />
            </div>
        </div>

        <div class="form-group">
            <label>Scuola frequentata:</label>
            <input type="text" v-model="school"/>
        </div>

        <div class="form-group">
            <label>Indirizzo scuola:</label>
            <input type="text" v-model="address"/>
        </div>

        <div class="form-group">
            <label>Hai mai usufruito di ripetizioni?</label>
            <div class="button-group">
            <button
                id="siUsatoRipetizioni"
                @click="alreadyUsedRepetitions = true"
                :class="{'active': alreadyUsedRepetitions}"
            >
                SI
            </button>
            <button
                id="noUsatoRipetizioni"
                @click="alreadyUsedRepetitions = false"
                :class="{'active': !alreadyUsedRepetitions}"
            >
                NO
            </button>
            </div>
        </div>

        <div class="form-group" v-if="alreadyUsedRepetitions">
            <label>Se hai usufruito di ripetizioni, con quale frequenza le hai utilizzate?</label>
            <select v-model="frequencyUsedTutoring">
            <option value="">Seleziona</option>
            <option value="Una volta l'anno">Circa una volta all'anno</option>
            <option value="Una volta al mese">Circa una volta al mese</option>
            <option value="Una volta a settimana">Circa una volta a settimana</option>
            <option value="Più volte a settimana">Più volte a settimana</option>
            </select>
        </div>

        <div class="form-group" v-if="alreadyUsedRepetitions">
            <label>Ho già ricevuto ripetizioni online (per es. Zoom, Google Meet o altro)</label>
            <div class="button-group">
            <button
                id="siRipetizioniOnline"
                @click="setRicevutoRipetizioniOnline(true)"
                :class="{'active': alreadyUsedTutoringOnline}"
            >
                SI
            </button>
            <button
                id="noRipetizioniOnline"
                @click="setRicevutoRipetizioniOnline(false)"
                :class="{'active': !alreadyUsedTutoringOnline}"
            >
                NO
            </button>
            </div>
        </div>

        <div class="form-group" v-if="alreadyUsedTutoringOnline">
            <label>Se hai già ricevuto ripetizioni online, con quale frequenza le utilizzi?</label>
            <select v-model="frequencyOfOnlineTutoring">
            <option value="">Seleziona</option>
            <option value="Una volta l'anno">Circa una volta l'anno</option>
            <option value="Una volta al mese">Circa una volta al mese</option>
            <option value="Una volta a settimana">Circa una volta a settimana</option>
            </select>
        </div>

        <div class="form-group">
            <label>Hai mai dato ripetizioni?</label>
            <div class="button-group">
            <button
                id="siDatoRipetizioni"
                @click="setDatoRipetizioni(true)"
                :class="{'active': givenTutoring}"
            >
                SI
            </button>
            <button
                id="noDatoRipetizioni"
                @click="setDatoRipetizioni(false)"
                :class="{'active': !givenTutoring}"
            >
                NO
            </button>
            </div>
        </div>

        <div class="form-group" v-if="givenTutoring">
            <label>Se hai già dato ripetizioni, con quale frequenza le hai date?</label>
            <select v-model="frequencyGivenTutoring">
            <option value="">Seleziona</option>
            <option value="Una volta l'anno">Circa una volta all'anno</option>
            <option value="Una volta al mese">Circa una volta al mese</option>
            <option value="Una volta a settimana">Circa una volta a settimana</option>
            <option value="Più volte a settimana">Più volte a settimana</option>
            </select>
        </div>

        <div class="form-group" v-if="givenTutoring">
            <label>Ho già dato ripetizioni online (per es. Zoom, Google Meet o altro)</label>
            <div class="button-group">
            <button
                id="siDatoRipetizioniOnline"
                @click="setDatoRipetizioniOnline(true)"
                :class="{'active': givenTutoringOnline}"
            >
                SI
            </button>
            <button
                id="noDatoRipetizioniOnline"
                @click="setDatoRipetizioniOnline(false)"
                :class="{'active': !givenTutoringOnline}"
            >
                NO
            </button>
            </div>
        </div>

        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

        <button @click="validateForm">Invia</button>
        </div>
    </div>
</template>

<style scoped>
* {
  caret-color: transparent;
}

.container {
  margin-top: 15em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.questionario-box {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 80%;
  max-width: 500px;
  color: black;
}

.form-group {
  margin: 15px 0;
  text-align: left;
}

label {
  font-weight: bold;
  display: block;
}

input, select {
  caret-color: gray;
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.button-group button {
  flex: 1;
  max-width: 100px;
  padding: 8px;
}

button {
  background-color: white;
  color: black;
  padding: 10px 15px;
  border: 2px solid #007bff;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
}

button:hover {
  background-color: #007bff;
  color: white;
}

.button-group button.active {
  background-color: #007bff;
  color: white;
}

.error-message {
  color: red;
  font-weight: bold;
}

.input-group {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.input-group input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.input-classe {
  flex: 1 1 33%;
}

.input-section {
  flex: 1 1 33%;
}

.flex-group {
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.input-wrapper {
  flex: 1;
}
</style>